import { Checkbox, Dropdown, IDropdownOption, Stack, StackItem } from "@fluentui/react";
import * as React from "react";
import { useState } from "react";

interface Props {
    order: Order;
    updateOrder: (order: Order) => void;
}
const Contacted = (props: Props) => {
    const [isChecked, setIsChecked] = useState<boolean>(props.order.orderProperties && props.order.orderProperties.customerContacted ? true : false);
   

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setIsChecked(checked);
        props.updateOrder({...props.order, orderProperties: {...props.order.orderProperties, customerContacted: undefined}});
    } 
    const handleDropdownChange = (event: React.FormEvent<HTMLDivElement>, option: IDropdownOption) => {
        let customerContacted: string | undefined = option.key as string;
        if (!customerContacted)
        {
            customerContacted = undefined;
        }
       props.updateOrder({...props.order, orderProperties: {...props.order.orderProperties, customerContacted: customerContacted}});
    };
    const options: IDropdownOption[] = [
        {key: "Flyttet", text: "Kunde kontaktet - Flyttet"},
        {key: "Ikke flyttet", text: "Kunde kontaktet - Ikke flyttet"},
        {key: "Besked lagt", text: "Kunde kontaktet - Besked lagt"}
      
    ];

    return (
        <Stack  style={{maxWidth:"450px"}} horizontal grow={2}>
            <StackItem grow={0.5}>
                <Checkbox boxSide={"end"} checked={isChecked} onChange={handleCheckboxChange} label="Kunde kontaktet?" />
            </StackItem>
            <StackItem grow={1.5}>
            {isChecked && <Dropdown style={{maxWidth:"350px"}} onChange={handleDropdownChange} selectedKey={props.order.orderProperties && props.order.orderProperties.customerContacted} options={options} /> }
            </StackItem>
        </Stack>
    );
};
export default Contacted;